import React, { FC } from 'react';

type SocialIconsProps = {
  socialName: 'telegram' | 'instagram' | 'youtube' | 'twitter';
};

//TODO https://jira.tennisi.it/browse/SITE-598

export const SocialIcons: FC<SocialIconsProps> = ({ socialName }) => {
  switch (socialName) {
    case 'telegram':
      return (
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M17.9638 3.31482C17.9492 3.24764 17.9173 3.18555 17.8713 3.13483C17.8254 3.08411 17.767 3.04657 17.702 3.026C17.4655 2.97866 17.2208 2.99619 16.9933 3.07679C16.9933 3.07679 1.22258 8.807 0.321888 9.4415C0.128401 9.57796 0.0631549 9.65755 0.030907 9.75079C-0.125083 10.2056 0.360136 10.4012 0.360136 10.4012L4.42488 11.74C4.49361 11.7524 4.56428 11.7483 4.63111 11.7278C5.55505 11.1373 13.9305 5.78915 14.4172 5.60948C14.4922 5.58674 14.55 5.60948 14.535 5.66634C14.3415 6.35239 7.10371 12.8513 7.06396 12.8907C7.0446 12.9067 7.02951 12.9274 7.02008 12.9509C7.01065 12.9743 7.00717 12.9997 7.00996 13.0249L6.63049 17.0366C6.63049 17.0366 6.4715 18.2851 7.70667 17.0366C8.58261 16.1504 9.42331 15.4166 9.84328 15.0595C11.2412 16.0352 12.7448 17.1139 13.3936 17.6786C13.5027 17.7854 13.632 17.8688 13.7737 17.9239C13.9155 17.979 14.0667 18.0047 14.2185 17.9993C14.4054 17.9763 14.5809 17.8963 14.7217 17.7699C14.8625 17.6436 14.9619 17.4769 15.0067 17.292C15.0067 17.292 17.879 5.60039 17.975 4.03422C17.9848 3.88261 17.9975 3.78255 17.999 3.67718C18.0037 3.55533 17.9918 3.43341 17.9638 3.31482Z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd"
                clipRule="evenodd"
                d="M1 5C1 2.79086 2.79086 1 5 1H15C17.2091 1 19 2.79086 19 5V15C19 17.2091 17.2091 19 15 19H5C2.79086 19 1 17.2091 1 15V5ZM14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10ZM15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z" />
        </svg>
      );
    case 'youtube':
      return (
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M19.8333 6C19.8333 6 19.6667 4.58333 19 4C18.25 3.16667 17.4167 3.16667 17 3.16667C14.1667 3 10 3 10 3C10 3 5.83333 3 3 3.16667C2.58333 3.25 1.75 3.25 1 4C0.416667 4.58333 0.166667 6 0.166667 6C0.166667 6 0 7.58333 0 9.25V10.75C0 12.3333 0.166667 14 0.166667 14C0.166667 14 0.333333 15.4167 1 16C1.75 16.8333 2.75 16.75 3.16667 16.8333C4.75 17 10 17 10 17C10 17 14.1667 17 17 16.75C17.4167 16.6667 18.25 16.6667 19 15.9167C19.5833 15.3333 19.8333 13.9167 19.8333 13.9167C19.8333 13.9167 20 12.3333 20 10.6667V9.16667C20 7.58333 19.8333 6 19.8333 6ZM7.91667 12.5833V7L13.3333 9.83333L7.91667 12.5833Z" />
        </svg>
      );
    case 'twitter':
      return (
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M20 3.81353C19.25 4.14343 18.5 4.39085 17.6667 4.47333C18.5 3.97848 19.1667 3.15374 19.5 2.24652C18.6667 2.74137 17.8333 3.07127 16.9167 3.23621C16.1667 2.41147 15.0833 1.91663 13.9167 1.91663C11.6667 1.91663 9.83333 3.73106 9.83333 5.95786C9.83333 6.28776 9.83333 6.61766 9.91667 6.86508C6.41667 6.70013 3.41667 5.05065 1.41667 2.57642C1 3.23621 0.833333 3.89601 0.833333 4.63828C0.833333 6.04034 1.58333 7.27745 2.66667 8.01972C2 8.01972 1.33333 7.85477 0.833333 7.52487C0.833333 7.52487 0.833333 7.52487 0.833333 7.60735C0.833333 9.58673 2.25 11.2362 4.08333 11.5661C3.75 11.6486 3.41667 11.7311 3 11.7311C2.75 11.7311 2.5 11.7311 2.25 11.6486C2.75 13.2981 4.25 14.4527 6.08333 14.4527C4.66667 15.5249 2.91667 16.1847 1 16.1847C0.666667 16.1847 0.333333 16.1847 0 16.1022C1.83333 17.2568 4 17.9166 6.25 17.9166C13.8333 17.9166 17.9167 11.7311 17.9167 6.37023C17.9167 6.20529 17.9167 6.04034 17.9167 5.87539C18.75 5.29807 19.4167 4.5558 20 3.81353Z" />
        </svg>
      );
    default:
      assertExhaustiveness(socialName);
  }
};
